<template>
  <printBase ref="LinkQR006" :title='title' :width='800'>
    <div slot="content" class="printLinkQR">
      <div class="printTitle">首营品种审批表</div>
      <div>
        <span>品种编号：{{printInfo.goodsBaseDrugSerialCode}}</span>
        <span class="minPrintTitle" style="margin-right:60px;">年</span>
        <span class="minPrintTitle" style="margin-right:30px;">月</span>
        <span class="minPrintTitle">日</span>
      </div>
      <table style="width: 100%" class='printContent' border='1' cellspacing="0">
        <tbody>
          <tr height='40'>
            <td style="width:15%"><span>商品通用名称</span></td>
            <td colspan="2"><span>{{ printInfo.goodsBaseApprovedDrugNames }}</span></td>
            <td style="width:8%;" rowspan="2"><span>上市许可持有人</span></td>
            <td colspan="3" rowspan="2"><span>{{ printInfo.goodsBaseMah }}</span></td>
            <td style="width:9%" rowspan="2"><span>自带条码</span></td>
            <td colspan="2" rowspan="2"><span>{{ printInfo.goodsBaseBarCode }}</span></td>
          </tr>
          <tr height='30'>
            <td><span>商品名</span></td>
            <td colspan="2"><span>{{ printInfo.goodsBaseGoodsName }}</span></td>
          </tr>
          <tr height='30'>
            <td><span>剂型</span></td>
            <td style="width:10%"><span>规格</span></td>
            <td style="width:15%"><span>单位</span></td>
            <td><span>装箱规格</span></td>
            <td colspan="3"><span>批准文号</span></td>
            <td colspan="2"><span>用法用量</span></td>
            <td style="width:9%"><span>存储条件</span></td>
          </tr>
          <tr height='30'>
            <td><span>{{ printInfo.goodsBaseVODosageFormString }}</span></td>
            <td><span>{{ printInfo.goodsBaseSpecifications }}</span></td>
            <td><span>{{ printInfo.goodsBaseVODrugMiniPackageUnitString }}</span></td>
            <td><span>{{  }}</span></td>
            <td colspan="3"><span>{{ printInfo.goodsBaseApprovalNumber }}</span></td>
            <td colspan="2"><span>{{  }}</span></td>
            <td><span>{{ printInfo.goodsBaseVOStorageConditionsString }}</span></td>
          </tr>
          <tr height='30'>
            <td><span>成份</span></td>
            <td colspan="4"><span>{{ printInfo.goodsBaseChemicalComposition }}</span></td>
            <td style="width:11%" colspan="2"><span>质量标准</span></td>
            <td colspan="3"><span>{{ printInfo.goodsBaseDrugAcceptanceStandard }}</span></td>
          </tr>
          <tr height='30'>
            <td><span>供货企业名称</span></td>
            <td colspan="2"><span>{{ printInfo.supplierStoreName }}</span></td>
            <td><span>注册地址</span></td>
            <td colspan="3"><span>{{ printInfo.supplierStoreRigistryAddress }}</span></td>
            <td ><span>法人代表</span></td>
            <td colspan="2"><span>{{ printInfo.supplierStoreCorporationPerson }}</span></td>
          </tr>
          <tr height='30'>
            <td rowspan="2"><span>生产企业名称</span></td>
            <td colspan="2" rowspan="2"><span>{{ printInfo.goodsBaseManufacturer }}</span></td>
            <td rowspan="2"><span>生产许可证</span></td>
            <td colspan="3" class='alignLeft'><span>编号：{{ printInfo.goodsBaseProdLicenseCode }}</span></td>
            <td rowspan="2"><span>GMP证书</span></td>
            <td colspan="2" class='alignLeft'><span>编号：{{ printInfo.goodsBaseGmpCertCode }}</span></td>
          </tr>
          <tr height='45'>
            <td colspan="3" class='alignLeft'><span>有效期：{{ printInfo.goodsBasePeriodProdLicense }}</span></td>
            <td colspan="3" class='alignLeft'><span>有效期：{{ printInfo.goodsBasePeriodGmpCert}}</span></td>
          </tr>
          <tr height='60'>
            <td><span>功能主治或适应症</span></td>
            <td colspan="3"><span>{{  }}</span></td>
            <td colspan="2" style="width:19%"><span>不良反应和禁忌</span></td>
            <td colspan="4"><span>{{  }}</span></td>
          </tr>
          <tr height='260'>
            <td><span>首营品种资料</span></td>
            <td colspan="6" class='alignLeft'>
              <input type="checkbox">药品批准证明文件复印件<br/>
              <input type="checkbox">药品质量标准复印件<br/>
              <input type="checkbox">药品省检报告复印件<br/>
              <input type="checkbox">药品厂检报告书复印件<br/>
              <input type="checkbox">生物制品批签发合格证复印件<br/>
              <input type="checkbox">药品包装、说明书批件复印件<br/>
              <input type="checkbox">药品包装盒、说明书样本<br/>
              <input type="checkbox">价格批文复印件<br/>
              <input type="checkbox">注册商标批件复印件<br/>
              <span>要求：</span><br/>
              <span>1、以上证明文件及复印件需加盖企业原印章（公章）；</span><br/>
              <span>2、首次购进的质量检验报告书批号与药品包装盒的批号一致；</span><br/>
              <span>3、如有资料在对应内框划“√”</span>
            </td>
            <td colspan="3" class="alignNone"><span class="leftTop">备注：</span></td>

          </tr>
          <tr height='70'>
            <td><span>采购员意见</span></td>
            <td colspan="17" class="alignNone">
              <div class="signOpinion">同意</div>
              <div class="rightBottom">
                <span class="indentationRight">签名：{{ printInfo.node1.modifiedUserName }}</span>
                <span v-if='printInfo.node1.modifiedTime'>{{ printInfo.node1.modifiedTime }}</span>
                  <template v-else>
                    <span style="margin-right:18px;">年</span>
                    <span style="margin-right:18px;">月</span>
                    <span>日</span>
                  </template>
              </div>
            </td>
          </tr>
          <tr height='70'>
            <td><span>质量负责人意见</span></td>
            <td colspan="17" class="alignNone">
                <div class="signOpinion">{{ printInfo.node2.idea }}</div>
                <div class="rightBottom">
                  <span class="indentationRight">签名：{{ printInfo.node2.modifiedUserName }}</span>
                  <span v-if='printInfo.node2.modifiedTime'>{{ printInfo.node2.modifiedTime }}</span>
                  <template v-else>
                    <span style="margin-right:18px;">年</span>
                    <span style="margin-right:18px;">月</span>
                    <span>日</span>
                  </template>
                </div>
            </td>
          </tr>
          <tr height='70'>
            <td><span>企业负责人意见</span></td>
            <td colspan="17" class="alignNone">
                <div class="signOpinion">{{ printInfo.node3.idea }}</div>
                <div class="rightBottom">
                  <span class="indentationRight">签名：{{ printInfo.node3.modifiedUserName }}</span>
                  <span v-if='printInfo.node3.modifiedTime'>{{ printInfo.node3.modifiedTime }}</span>
                  <template v-else>
                    <span style="margin-right:18px;">年</span>
                    <span style="margin-right:18px;">月</span>
                    <span>日</span>
                  </template>
                </div>
            </td>
          </tr>
        </tbody>
        </table>
    </div>
  </printBase>
</template>
<script>
import printBase from './printBase';
import goods from '../../services/goods';
import utils from '../../libs/utils';

export default {
  props: {
    value: {
      type: Object,
    },
  },
  watch: {
    value: {
      handler() {},
      deep: true,
    },
  },
  data() {
    return {
      title: 'Link-QR-006',
      id: 'LinkQR006',
      printInfo: {
        node1: {
          idea: '',
          modifiedTime: '',
        },
        node2: {
          idea: '',
          modifiedTime: '',
        },
        node3: {
          idea: '',
          modifiedTime: '',
        },
      },
    };
  },
  components: {
    printBase,
  },
  methods: {
    handlePrint(id) {
      goods.getGoodsStorePrintInfo({ id }).then((res) => {
        if (res.data.status === 200) {
          const result = {
            node1: {
              modifiedTime: '',
            },
            node2: {},
            node3: {},
          };
          utils.exchangeTable(res.data.data, result);
          result.goodsBasePeriodProdLicense = utils.formatTime(result.goodsBasePeriodProdLicense, 'YYYY/MM/DD');
          result.goodsBasePeriodGmpCert = utils.formatTime(result.goodsBasePeriodGmpCert, 'YYYY/MM/DD');
          result.workRecordList.forEach((item) => {
            // 采购员信息填写提交人信息
            if (item.roleId === 2) {
              result.node1.modifiedUserName = item.createUserName ? item.createUserName : '';
              if (item.createTime) {
                result.node1.modifiedTime = utils.formatTime(item.createTime, 'YYYY年MM月DD日');
              }
              result.node2.idea = item.idea ? item.idea : '';
              result.node2.modifiedUserName = item.modifiedUserName ? item.modifiedUserName : '';
              if (item.modifiedTime) {
                result.node2.modifiedTime = utils.formatTime(item.modifiedTime, 'YYYY年MM月DD日');
              }
            }
            if (item.roleId === 1) {
              result.node1.modifiedUserName = item.createUserName ? item.createUserName : '';
              if (item.createTime) {
                result.node1.modifiedTime = utils.formatTime(item.createTime, 'YYYY年MM月DD日');
              }
              result.node3.idea = item.idea ? item.idea : '';
              result.node3.modifiedUserName = item.modifiedUserName ? item.modifiedUserName : '';
              if (item.modifiedTime) {
                result.node3.modifiedTime = utils.formatTime(item.modifiedTime, 'YYYY年MM月DD日');
              }
            }
          });
          this.printInfo = result;
          this.$nextTick(() => {
            this.$refs.LinkQR006.handlePrint();
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.printContent td,th{
    text-align: center;
    position: relative;
    border-color: #000;
    font-weight: 300;
    word-break: break-all;
    padding: 2px 6px;
    font-size: 12px;
    *{
      display: inline-block;
      max-height: 50px;
      overflow:hidden
    }

  }
</style>
